import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default function RevenueFields() {
  return (
    <>
      <Row>
        <Col></Col>
      </Row>
      <Row>
        <Col>Revenue</Col>
      </Row>
      <Row>
        <Col>Fully Loaded Cost</Col>
      </Row>
      <Row>
        <Col>Unloaded Cost</Col>
      </Row>
      <Row>
        <Col>Other Cost</Col>
      </Row>
      <Row>
        <Col>Total Cost</Col>
      </Row>
      <Row>
        <Col>Profit before Tax</Col>
      </Row>
      <Row>
        <Col>Profit net of Tax</Col>
      </Row>
    </>
  )
}
